import { NgModule } from '@angular/core';

// Common PrimeNG Modules
import { DialogModule } from 'primeng/dialog';
import { CarouselModule } from 'primeng/carousel';
import { AvatarModule } from 'primeng/avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule, ButtonDirective } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';

const PRIME_NG_MODULES = [
  DialogModule,
  CarouselModule,
  AvatarModule,
  AutoCompleteModule,
  ButtonModule,
  ButtonDirective,
  CalendarModule,
  DividerModule,
  FloatLabelModule,
  InputGroupModule,
  InputGroupAddonModule,
  InputOtpModule,
  InputTextareaModule,
  InputTextModule,
  ProgressBarModule,
  SidebarModule,
  ToastModule,
  CheckboxModule,
  DropdownModule,
  TagModule,
];

@NgModule({
  imports: PRIME_NG_MODULES,
  exports: PRIME_NG_MODULES,
})
export class PrimeNgModule {}
